import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Background from "@/components/Background";
import InteractiveBackgroundLayer from "@/components/InteractiveBackgroundLayer";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import RequestDemoModal from "@/components/RequestDemoModal";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import BrandKit from "@/pages/BrandKit";
import AgricultureQC from "@/pages/AgricultureQC";
import FoodDistribution from "@/pages/FoodDistribution";
import Restaurants from "@/pages/Restaurants";
import SupplyChain from "@/pages/SupplyChain";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function Shell() {
  const [demoOpen, setDemoOpen] = useState(false);
  const open = () => setDemoOpen(true);
  const close = () => setDemoOpen(false);

  return (
    <>
      <Navbar onRequestDemo={open} />
      <main className="relative z-10">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home onRequestDemo={open} />} />
          <Route path="/about" element={<About onRequestDemo={open} />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/brand" element={<BrandKit />} />
          <Route path="/industries/agriculture" element={<AgricultureQC onRequestDemo={open} />} />
          <Route path="/industries/food-distribution" element={<FoodDistribution onRequestDemo={open} />} />
          <Route path="/industries/restaurants" element={<Restaurants onRequestDemo={open} />} />
          <Route path="/industries/supply-chain" element={<SupplyChain onRequestDemo={open} />} />
          <Route path="*" element={<Home onRequestDemo={open} />} />
        </Routes>
      </main>
      <Footer />
      <RequestDemoModal open={demoOpen} onClose={close} />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <Background />
      <InteractiveBackgroundLayer />
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}

export default App;
